<template>
  	<FlexResellerList />
</template>

<script>

// @ is an alias to /src
import FlexResellerList from "@/components/ResellerList.vue";

export default {
  name: "FlexResellerLists",
  components: {
    FlexResellerList,
  },
};
</script>
